import * as React from "react";
import * as fp from "lodash/fp";
import Img from "modules/cars/rating/tires/views/Img";

import "./TireSizePopup.scss";
import Device from "modules/cars/rating/components/Device";

const img = {
    fileName: "tire_illustration_p@2x",
    relativePath: "/prod/content/dam/cro/cars/tires/",
    cloudFrontDomain: "//res.cloudinary.com/consumer-reports-cld",
    fileFormat: "png",
    size: 200
};

const OkButton = ({onClick = fp.noop}) =>
    <a href="javascript:void(0);" onClick={onClick} className="crux-btn crux-btn-primary--sm" role="button">
        OK, Got it
    </a>

export default ({onHide = fp.noop, title}) =>
    <div className="cr-rating__tire-size-popup cr-d-flex cr-flex-column">
        <div className="cr-d-flex cr-justify-content-end">
            <a href="javascript:void(0);" className="cr-rating__tire-size-popup__close-btn"  onClick={onHide}>
                <span className="crux-icons crux-icons-close" aria-hidden="true"/>
            </a>
        </div>

        <div className="cr-d-flex cr-flex-row cr-flex-xs-column-reverse cr-pb-2 cr-pb-xs-0">
            <div className="crux-component-title cr-flex-1 cr-py-xs-1">
                {title}
            </div>
            <div className="cr-d-flex cr-justify-content-center cr-align-items-center cr-flex-1 cr-pb-xs-2">
                <Img {...img} className="img-responsive" alt='What is my tire size?'/>
            </div>
        </div>

        <div className="cr-d-flex cr-flex-row cr-flex-xs-column">

            <div className="cr-flex-1 cr-d-flex cr-flex-column cr-justify-content-between">
                <div>
                    <p className="cr-rating__tire-size-popup__guide-text">
                        Examine your existing tires to determine their correct size.
                    </p>
                    <p className="cr-rating__tire-size-popup__guide-text">
                        The size is made up of multiple parameters (as shown in this example):
                    </p>
                </div>

                <Device exclude mobile>
                    <div className="crux-body-copy">
                        <OkButton onClick={onHide}/>
                    </div>
                </Device>
            </div>

            <div className="cr-flex-1 cr-d-flex cr-flex-column cr-justify-content-between">
                <div className="cr-rating__tire-size-popup__measurement">
                    <div className="cr-rating__tire-size-popup__measurement__number">
                        P — &nbsp;
                    </div>
                    <div className="cr-rating__tire-size-popup__measurement__description">
                        Tire type
                    </div>
                </div>

                <div className="cr-rating__tire-size-popup__measurement">
                    <div className="cr-rating__tire-size-popup__measurement__number">
                        215 — &nbsp;
                    </div>
                    <div className="cr-rating__tire-size-popup__measurement__description">
                        Tire width in millimeters
                    </div>
                </div>

                <div className="cr-rating__tire-size-popup__measurement">
                    <div className="cr-rating__tire-size-popup__measurement__number">
                        45 — &nbsp;
                    </div>
                    <div className="cr-rating__tire-size-popup__measurement__description">
                        Sidewall height to width aspect ratio
                    </div>
                </div>

                <div className="cr-rating__tire-size-popup__measurement">
                    <div className="cr-rating__tire-size-popup__measurement__number">
                        R — &nbsp;
                    </div>
                    <div className="cr-rating__tire-size-popup__measurement__description">
                        Tire construction
                    </div>
                </div>

                <div className="cr-rating__tire-size-popup__measurement">
                    <div className="cr-rating__tire-size-popup__measurement__number">
                        17 — &nbsp;
                    </div>
                    <div className="cr-rating__tire-size-popup__measurement__description">
                        Wheel diameter in inches
                    </div>
                </div>
            </div>

        </div>
        <Device mobile>
            <div className="crux-body-copy cr-pt-xs-2">
                <OkButton onClick={onHide}/>
            </div>
        </Device>
    </div>;



// WEBPACK FOOTER //
// ./resources/modules/cars/rating/tires/views/TireSizePopup.tsx